/*  eslint-disable no-unused-vars, react/no-unescaped-entities */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { faYoutube, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './SocialHandles2.css';

const SocialHandles2 = () => (
  <div style={{ margin: '2rem 0' }}>
    <a target="_blank" rel="noreferrer" href="https://www.youtube.com/@curvsort" className="youtube social" aria-label="YouTube Channel">
      <FontAwesomeIcon icon={faYoutube} size="2x" />
    </a>
    <a target="_blank" rel="noreferrer" href="https://www.twitter.com/CurvSort" className="twitter social" aria-label="X Profile">
      <FontAwesomeIcon icon={faXTwitter} size="2x" />
    </a>
  </div>
);

const FindUs = () => {
  const navigate = useNavigate();
  return (
    <div id="contactus">
      <div className="app__headerFU app__wrapper section__padding" style={{ gap: '4rem' }}>
        <div className="app__wrapper_img">
          <div className="lexiLensImage">
            <img src={images.FindUsLogo} alt="contact_office" />
          </div>
        </div>

        <div className="app__wrapper_info">
          <SubHeading title="Corporate Headquarters & Strategic Inquiries" />
          <h1 className="headtext__cormorant" style={{ marginBottom: '2rem' }}>Connect With Us</h1>

          <div className="app__wrapper-content">
            <p className="p__cormorant" style={{ color: '#DCCA87', fontSize: '1.4rem' }}>Operational Hours</p>
            <p className="p__opensans">Monday - Friday: 10:00 AM - 06:00 PM (IST)</p>

            <p className="p__cormorant" style={{ color: '#DCCA87', fontSize: '1.4rem', marginTop: '1.5rem' }}>Corporate Address</p>
            <p className="p__opensans" style={{ fontWeight: 'bold' }}>CurvSort Private Limited</p>
            <p className="p__opensans" style={{ lineHeight: '1.6' }}>
              203, Tower 3, Tata Promont, Banashankari III Stage, Bangalore South, Bangalore - 560085, Karnataka, India
            </p>
            {/* <SocialHandles2 /> */}
          </div>

          <div className="buildWithUs_Container">
            <div className="buildWithUs">
              <div className="buildWithUs1">
                Engaging with distributed AI systems, infrastructure partnerships, or enterprise deployments? Initiate a strategic briefing with CurvSort.
              </div>
              <div className="buildWithUs2">
                <div className="exploreTrack" onClick={() => navigate('/reachUsForm')}>
                  <div>Request Briefing</div>
                  <FontAwesomeIcon icon={faAngleDoubleRight} />
                </div>
              </div>
            </div>
            <div className="buildWithUs3">
              <FontAwesomeIcon
                onClick={() => { navigate('/'); window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); }}
                className="angleUpLogo"
                icon={faAngleDoubleUp}
              />
            </div>
          </div>

          <div className="policyContainer">
            <div className="policyTrack" onClick={() => navigate('/privacyPolicy')}>Privacy Policy</div>
            <div className="policyTrack" onClick={() => navigate('/customerSupport')}>Client Support</div>
            <div className="policyTrack" onClick={() => navigate('/cancellationPolicy')}>SLA & Cancellations</div>
            <div className="policyTrack" onClick={() => navigate('/termsAndConditions')}>Terms of Service</div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FindUs;
